import { FC } from 'react';
import { InputProps } from './input.type';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'input';

const Input: FC<InputProps> = (props) => {
  const {
    value,
    onChange,
    onBlur,
    placeholder,
    disabled,
    errorMessage,
    label,
    type = 'text',
    containerClassName,
    labelClassName,
    inputClassName,
    errorClassName,
    required,
    requiredClassName,
    useDefaultStyling = true,
  } = props;

  const prefix: string = idPrefix;

  // Default classes with focus border highlight
  const defaultInputClasses = `
    w-full rounded-full px-4 py-2 text-sm focus:outline-none
    ${disabled ? 'bg-[#E5E5E5] cursor-not-allowed' : 'bg-[#FAFAFA]'}
    ${
      errorMessage
        ? 'border border-[#B60000]' // Error border
        : 'border border-transparent focus:border-[#561BDC]' // Highlight on focus
    }
  `;

  const defaultErrorClasses = 'text-[#B60000] text-sm mt-1';

  // Onboarding style classes
  const onboardingInputClasses = `
    onboarding-input 
    ${errorMessage ? 'border-2 border-[#D80000] focus:ring-[#D80000]' : ''}
  `;

  const onboardingErrorClasses = 'text-[#D80000] text-sm mt-1';

  // Determine which final classes to use
  const finalInputClasses =
    inputClassName ||
    (useDefaultStyling ? defaultInputClasses : onboardingInputClasses);

  const finalErrorClasses =
    errorClassName ||
    (useDefaultStyling ? defaultErrorClasses : onboardingErrorClasses);

  return (
    <div
      className={containerClassName}
      {...getIdAttributes(prefix, 'container')}
    >
      {label && (
        <label
          className={
            labelClassName || 'block text-base text-black mb-1 font-helvetica'
          }
          {...getIdAttributes(prefix, 'label')}
        >
          {label}
          {required && (
            <span
              className={`text-black-500 ml-1 ${requiredClassName}`}
              {...getIdAttributes(prefix, 'required')}
            >
              *
            </span>
          )}
        </label>
      )}

      <input
        type={type}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={finalInputClasses}
        {...getIdAttributes(prefix, 'field')}
      />

      {errorMessage && (
        <div
          {...getIdAttributes(prefix, 'error')}
          className={finalErrorClasses}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default Input;
